import * as React from "react";
const SvgArrowDownConvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="20px"
    fill="none"
    viewBox="0 0 28 26"
    {...props}
  >
    <path
      fill="#1a7a73"
      d="M20.448 8.78H7.585c-1.043 0-1.564 1.244-.826 1.974l5.628 5.559c.901.89 2.368.89 3.27 0l2.14-2.114 3.487-3.445c.728-.73.206-1.975-.836-1.975"
    />
  </svg>
);
export default SvgArrowDownConvg;
